export * from './src/window.service';
export * from './src/rt-platform.service';
export * from './src/rt-platform.module';
